import { openApi } from '@/api/request'

export default {
  getUserInfo (userName) {
    const url = `/Rccl.OpenApi/User/GetUserPointApi`
    return openApi.post(url, {userName})
  },
  getUserDetail (userName) {
    const url = `/Rccl.OpenApi/User/GetUserEditInfoApi`
    return openApi.get(url, {
      params: {
        userName,
        v: (new Date()).getTime()
      }
    })
  },
  checkSignIn (userName) {
    return openApi.post('/Rccl.OpenApi/User/MemberSignInPointApi', { userName })
  },
  signIn ({ userName, source }) {
    return openApi.post('/Rccl.OpenApi/User/MemberSignInPointApi', { userName, source })
  },
  getSignInCount ({ userName, source }) {
    return openApi.post('/Rccl.OpenApi/User/CheckMemberSignInPointCntApi',{ userName, source })
  },
  getUserAllInfo (userName) {
    return openApi.post('/Rccl.OpenApi/UserCenter/Info', { userName })
  },
  userEditInfo (userName) {
    return openApi.post('/Rccl.OpenApi/User/GetUserEditInfoInPersonalCenter', { userName })
  },
  subEditInfo (data) {
    return openApi.post('/Rccl.OpenApi/User/SetUserEditInfoApi', data)
  },
  pyName ({lastName, firstName}) {
    return openApi.get('/Rccl.Core/Pinyin/GetPinyinName', {
      params: {
        lastName,
        firstName
      }
    })
  },
  getCountryList () {
    return openApi.get('/Rccl.OpenApi/Country/CountryList')
  },
  submitSuggestion (suggestion) {
    return openApi.post('/Rccl.OpenApi/UserCenter/SubmitSuggestionApi', suggestion)
  },
  getSuggestionCategory (userName) {
    return openApi.post('/Rccl.OpenApi/UserCenter/Suggestion', { userName })
  },
  userRelevanceInfoHP (userName) {
    return openApi.post('/Rccl.OpenApi/User/GetUserRelevanceInfoHPApi', { userName })
  },
  getAllCoupons (userName) {
    return openApi.get('/Rccl.OpenApi/User/UserCenterCouponApi', {
        params: {
            userName,
            v: (new Date()).getTime()
        }
    })
  },
  getPromoCruiseHP ({userName, plateform, isRow, type, shipCode, relatedCruiseIds, cruiseIds}) {
    return openApi.post('/Rccl.OpenApi/Cruise/GetPromoCruiseHPApi', {
        userName,
        plateform,
        isRow,
        type,
        shipCode,
        relatedCruiseIds,
        cruiseIds
    })
  },
  picCode (sessionKey) {
    return openApi.get('/Rccl.OpenApi/User/PictureVerificationCode', {
      params:{
        sessionKey,
        v: (new Date()).getTime()
      }
    })
  },
  smsCode (requestData) {
    return openApi.post('/Rccl.OpenApi/User/SendSmsCode', requestData)
  },
  SendSmsCodeWithPicCodeV3 (requestData) {
    return openApi.post('/Rccl.OpenApi/User/SendSmsCodeWithPicCodeV3', requestData)
  },
  // smsCodeLogin (requestData) {
  //   return openApi.post('/Rccl.OpenApi/User/SendSmsCodeV2', requestData)
  // },
  smsCodeLogin (requestData) {
    return openApi.post('/Rccl.OpenApi/User/SendSmsCodeV3', requestData)
  },
  login (requestData) {
    return openApi.post('/Rccl.OpenApi/User/LoginHp', requestData)
  },
  registeredMember (requestData) {
    return openApi.post('/Rccl.OpenApi/User/RegisterMemberHP', requestData)
  },
  isRegistered (mobile) {
    return openApi.get('/Rccl.OpenApi/User/isRegister', {
      params: {
        mobile,
        v: (new Date()).getTime()
      }
    })
  },
  isRegisteredMember (mobile) {
    return openApi.get('/Rccl.OpenApi/User/isRegisteredMember', {
      params: {
        phone: mobile,
        v: (new Date()).getTime()
      }
    })
  },
  checkHasRegister (telephone, callingCode) {
    return openApi.post('/Rccl.OpenApi/User/checkHasRegister', {
      telephone, callingCode
    })
  },
  getContact(userName,SearchType) {
    return openApi.get('/Rccl.OpenApi/User/GetUserContactsByUserName', {
      params: {
        userName: userName,
        SearchType:SearchType || 1,
        v: (new Date()).getTime()
      }
    })
  },
  getContactInPersonalCenter(userName) {
    return openApi.get('/Rccl.OpenApi/User/GetUserContactsByUserNameInPersonalCenter', {
      params: {
        userName: userName,
        v: (new Date()).getTime()
      }
    })
  },
  updateContact(contact) {
    return openApi.post('/Rccl.OpenApi/User/UpdateUserContact', contact)
  },
  createContact(contact) {
    return openApi.post('/Rccl.OpenApi/User/CreateUserContact', contact)
  },
  deleteContact (contact) {
    return openApi.post('/Rccl.OpenApi/User/DeleteUserContact', contact)
  },
  getCoupons (userName) {
    return openApi.get('/Rccl.OpenApi/User/UserCouponApi', {
      params: {
        userName,
        source: 'mobile',
        v: (new Date()).getTime()
      }
    })
  },
  getAvailableCoupons (userName) {
    return openApi.get('/Rccl.OpenApi/User/GetUserAvailableCoupons', {
      params: {
        userName,
        source: 'mobile',
        v: (new Date()).getTime()
      }
    })
  },
  GetGuestPolicyByCruise (requestData) {
    return openApi.get('/Rccl.OpenApi/PageContent/GetGuestPolicyByCruise', {
      params: requestData
    })
  },
  bindLoyalty (requestData) {
    return openApi.post('/Rccl.OpenApi/User/bindLoyalty', requestData)
  },
  createCas (requestData) {
    return openApi.post('/Rccl.OpenApi/User/CreateCasMember', requestData)
  },
  getPcpToken () {
    return openApi.post('/Rccl.OpenApi/User/GetPcpToken', {})
  },
  recommendLogin (requestData) {
    return openApi.post('/Rccl.OpenApi/User/RecommendLogin', requestData)
  },
  refreshCas () {
    return openApi.post('/Rccl.OpenApi/User/RefreshCas', {})
  },
  memberUpdateLevelAndCredit () {
    return openApi.post('/Rccl.OpenApi/User/MemberUpdateLevelAndCredit', {})
  },
  // 获得是否同意过最终的隐私政策-202508
  getUserAgreeVersionIsEffective(userName) {
    return openApi.post("/Rccl.OpenApi/User/GetUserAgreeVersionIsEffective", { userName })
  },
  // 确认同意最终的隐私政策-202508
  agreeToTheLastAgreement(requestData) {
    return openApi.post("/Rccl.OpenApi/User/AgreeToTheLastAgreement", requestData)
  },
  /**
   * 根据类型获取最新协议
   * @param requestData
   * userAgreementType: 1用户协议 2隐私政策 3皇家游享荟项目细则
   * @returns {*}
   */
  getAgreementByType(requestData) {
    return openApi.post("/Rccl.OpenApi/User/GetAgreementByType", requestData)
  },
  /**
   * 获取协议版本号列表
   * @param requestData
   * userAgreementType: 1用户协议 2隐私政策 3皇家游享荟项目细则
   * showMaxVersion: true:最新版本 false:历史版本 默认false，是否显示最大版本号
   * @returns {*}
   */
  getAgreeVersionNumberListByType(requestData) {
    return openApi.post("/Rccl.OpenApi/User/GetAgreeVersionNumberListByType", requestData)
  },
  /**
   * 根据参数获取协议
   * @param requestData
   * userAgreementType: 1用户协议 2隐私政策 3皇家游享荟项目细则
   * ver: 版本号
   * effectiveDateStr: 生效时间
   * id: 协议id
   * @returns {*}
   */
  getAgreementByParams(requestData) {
    return openApi.post("/Rccl.OpenApi/User/GetAgreementByParams", requestData)
  },
  // 获得是否同意过最终的隐私政策
  getUserVersionIsEffective (userName) {
    return openApi.post("/Rccl.OpenApi/User/GetUserVersionIsEffective", { userName })
  },
  // 确认同意隐私条款接口
  agreePrivacyPolicy (userName) {
    return openApi.post("/Rccl.OpenApi/User/AgreePrivacyPolicy", { userName })
  },
  // 获取用户是否开启隐私保护
  changePrivacyProtectionIsOpen (userName) {
    return openApi.post("/Rccl.OpenApi/UserCenter/ChangePrivacyProtectionIsOpen", { userName })
  },
  // // 更新用户是否开启隐私保护
  // updateUserPrivacyProtection (requestData) {
  //   return openApi.post("/Rccl.OpenApi/UserCenter/UpdateUserPrivacyProtection", requestData)
  // },

  // 更新用户是否开启隐私保护
  updateUserPrivacyProtection (requestData) {
    return openApi.post("/Rccl.OpenApi/UserCenter/UpdateUserPrivacyProtectionV1", requestData)
  },

  // 注销前验证接口
  cancellationCheck (userName) {
    return openApi.post('/Rccl.OpenApi/MemberCancellation/Check', { userName })
  },

  // 二次确认提交注销申请
  cancellationSubmit (data) {
    return openApi.post('/Rccl.OpenApi/MemberCancellation/Submit', data)
  },

  // 判断用户是否入会
  IsRegisteredMemberApi (userName) {
    return openApi.get('/Rccl.OpenApi/User/IsRegisteredMemberApi', {
      params: {
        userName: userName,
        v: (new Date()).getTime()
      }
    })
  },

   createUserBrowsingRecordApi(requestData) {
    return openApi.post('/Rccl.OpenApi/User/CreateUserBrowsingRecord', requestData)
  },
}
